import { contactFactory } from '@rtls/core/models/human/contact.factory';
import { addressFactory } from '@rtls/core/models/location/address.factory';
import { companyFactory } from '@rtls/core/models/location/company.factory';
import { locationTypeFactory } from '@rtls/core/models/location/location-type.factory';
import { Location } from '@rtls/core/models/location/location.model';
import {
	nullable,
	random,
	randomDate,
	randomName,
	randomNumber,
	randomShapes,
	randomSizeList,
} from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts/lib';

export const locationFactory = Factory.makeFactory<Location>({
	id: Factory.each((i) => nullable(i)),
	createdDate: Factory.each(() => nullable(randomDate())),
	updatedDate: Factory.each(() => nullable(randomDate())),
	deletedDate: Factory.each(() => nullable(randomDate(), 3)),
	thingCount: Factory.each(() => nullable(randomNumber())),
	shapes: Factory.each(() => randomShapes()),
	type: Factory.each(() => locationTypeFactory.build()),
	name: Factory.each(() => randomName()),
	address: Factory.each(() => nullable(addressFactory.build())),
	contact: contactFactory.build(),
	companies: Factory.each(() =>
		randomSizeList(
			() => companyFactory.build(),
			3,
			() => random(30),
		),
	),
	railCarrierType: {} as any,
});
